import triyoAPI from "./triyo";
import { getToken } from "./api-util";

const config = () => {
  let token = getToken();
  return {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const LaunchTeamsGroupChatForTask = (data) => {
    return triyoAPI.post(
      `LaunchTeamsGroupChatForTask`,
      data,
      config()
    );
};

export const CreateChatGroupWithToken = (data) => {
  return triyoAPI.post(
    `CreateChatGroupWithToken`,
    data,
    config()
  );
};

export const CreateChatWithAzureIdentity = (data) => {
  return triyoAPI.post(
    `createazureidentity`,
    data,
    config()
  );
};

export const CreateChatWithMSAL = (data) => {
  return triyoAPI.post(
    `createmsal`,
    data,
    config()
  );
};
